let isLoading = false;
let isLoaded = false;

export function useYandexMaps() {
  const load = (): Promise<void> => new Promise((resolve) => {
    if (isLoaded && window.ymaps) {
      resolve();
      return;
    }

    if (isLoading) {
      const interval = setInterval(() => {
        if (window.ymaps) {
          clearInterval(interval);
          resolve();
        }
      }, 50);

      return;
    }

    isLoading = true;
    const script = document.createElement('script');
    script.src = `https://api-maps.yandex.ru/2.1/?apikey=${process.env.VUE_APP_YANDEX_MAP_KEY}&lang=ru_RU`;

    script.onload = () => {
      isLoaded = true;
      isLoading = false;
      resolve();
    };

    document.head.appendChild(script);
  });

  return { load };
}

declare global {
  interface Window {
    ymaps: any,
  }
}
